import { useRef } from "react";
import { motion, useReducedMotion, useScroll, useSpring, useTransform } from "framer-motion";

/**
 * Moves its children vertically as the element travels through the viewport.
 * `distance` is the total travel in pixels (positive = moves up on scroll down).
 */
export const Parallax = ({ children, distance = 60, className = "" }) => {
    const ref = useRef(null);
    const reduce = useReducedMotion();
    const { scrollYProgress } = useScroll({
        target: ref,
        offset: ["start end", "end start"],
    });
    const raw = useTransform(scrollYProgress, [0, 1], [distance / 2, -distance / 2]);
    const y = useSpring(raw, { stiffness: 90, damping: 22, mass: 0.4 });

    return (
        <div ref={ref} className={className}>
            <motion.div style={reduce ? undefined : { y }}>{children}</motion.div>
        </div>
    );
};
